module.exports = __webpack_public_path__ + "img/bot_03.5405a98e.png";